export default __webpack_public_path__ + "static/Auftragsabwicklung-3bc679bd0641748055fe9f0e86aab5fe.png";